import { useSearch } from '../../../../hooks/context';

/**
 * Custom hook to retrieve intervention data and associated class names.
 *
 * @returns {Object} The intervention data with the appropriate class names and properties.
 */

const useIntervention = () => {
  const { results } = useSearch();

  const findResultByType = (type) => results.find((result) => result?.type === type);

  const isZrpDisclaimer = findResultByType('ZRP_DISCLAIMER_COMPONENT');
  const isAndesMessage = findResultByType('ANDES_MESSAGE_INTERVENTION');

  const disclaimer = isZrpDisclaimer || isAndesMessage;

  if (disclaimer) {
    return {
      ...disclaimer,
      closable: true,
    };
  }

  return {
    disclaimer,
  };
};

export default useIntervention;
